module.exports = __webpack_public_path__ + "static/media/image1.7798bce1.JPG";